import { ComponentOptions } from 'vue';

export const cartErrorsMixin: ComponentOptions<Vue> = {
  computed: {
    displayedErrorsMultiInfo(): Array<{ message: string }> {
      const getBet = (this as any).getBet;
      if (getBet.errors_multi_info && getBet.errors_multi_info.length > 0) {
        return getBet.errors_multi_info;
      }

      // Per il sistema, la molteplicità non si applica globalmente
      if (getBet.type === 'system') {
        return [];
      }

      // Fallback: replica di multiplicityVincolsInfo
      let multiplicity = 0;
      if (getBet.type === 'single' || getBet.type === 'multiple') {
        multiplicity = +getBet._multiple_detail.multiplicity;
      } else if (getBet.type === 'integral') {
        multiplicity = +getBet._integral_detail.multiplicity;
      }
      let multiMinimum = 0;
      for (const odd of getBet.odds || []) {
        if (odd && +odd.multiplicity_min > multiMinimum)
          multiMinimum = +odd.multiplicity_min;
      }
      if (multiplicity < multiMinimum && multiMinimum > 0) {
        return [{ message: `multiplicity_info_${multiMinimum}` }];
      }
      return [];
    },
    displayedErrors(): Array<{ message: string; value?: number }> {
      const getBet = (this as any).getBet;
      if (getBet.errors && getBet.errors.length > 0) {
        return getBet.errors;
      }
      // Fallback: replica minima di amountVincols per min/max
      const errors: Array<{ message: string; value?: number }> = [];
      const ctx = getBet.context;
      const getSettings = (this as any).getSettings;
      const settings = getSettings || {};
      let amount = 0;
      if (getBet.type === 'single' || getBet.type === 'multiple') {
        amount = +getBet._multiple_detail.amount;
      } else if (getBet.type === 'integral') {
        amount = +getBet._integral_detail.amount;
      } else if (getBet.type === 'system') {
        amount = +getBet._system_detail.amount_system;
      }
      if (ctx === 'prematch') {
        const minAmount = settings.minAmount;
        const prematchMax = settings.prematch_max_amount;
        if (minAmount != null && +minAmount > 0 && amount < +minAmount) {
          errors.push({
            message: 'minimumAmountNotRespected',
            value: +minAmount
          });
        }
        if (prematchMax != null && +prematchMax > 0 && amount > +prematchMax) {
          errors.push({
            message: 'maximumAmountNotRespected',
            value: +prematchMax
          });
        }
      } else if (ctx === 'live' || ctx === 'mixed') {
        const liveMin = settings.live_min_amount;
        const liveMax = settings.live_max_amount;
        if (liveMin != null && +liveMin > 0 && amount < +liveMin) {
          errors.push({
            message: 'minimumAmountNotRespected',
            value: +liveMin
          });
        }
        if (liveMax != null && +liveMax > 0 && amount > +liveMax) {
          errors.push({
            message: 'maximumAmountNotRespected',
            value: +liveMax
          });
        }
      }
      return errors;
    },
    displayedWarnings(): Array<{ message: string; value?: number }> {
      const getBet = (this as any).getBet;
      return getBet.warnings || [];
    }
  }
};
